export interface Logger {
  trace: (...args: any[]) => void;
  debug: (...args: any[]) => void;
  info: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  error: (...args: any[]) => void;
}

const logger = Object.freeze({
  trace: (...args: any[]) => (console.trace || console.log)(...args),
  debug: (...args: any[]) => (console.debug || console.log)(...args),
  info: (...args: any[]) => (console.info || console.log)(...args),
  warn: (...args: any[]) => (console.warn || console.log)(...args),
  error: (...args: any[]) => (console.error || console.log)(...args),
});

export const getLogger: () => Logger = () => logger;
